import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import { Button, CircularProgress, makeStyles } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'
import { dateFormatter } from '../../Models/CommonFunc'
import classNames from 'classnames';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import CustomAlert from '../../CustomAlert';
import mapValues from 'lodash/mapValues';
import { Helmet } from 'react-helmet';
import { getProductDocumentWithUserId } from '../../../Backend/firebase/product';
import { getProductAndSalesDocumentWithUniqueId, updateProductAndSalesDocument } from '../../../Backend/firebase/product-and-sales';

const useStyles = makeStyles((theme) => ({
    root: {

        '& .MuiFormControlLabel-label.Mui-disabled': {
            color: 'white'
        }
    },
}));

function UpdateProductAndSales({ _id, productAndSalesId, setOpenPopup, refreshData }) {
    const classes = useStyles();
    const { register, handleSubmit, errors, reset, setValue } = useForm();
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [ExpiryDate, setExpiryDate] = useState(new Date())
    const [isExpiryDateModified, setIsExpiryDateModified] = useState(false);
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [isEnabledProductSize, setIsEnabledProductSize] = useState(false);
    const [IsProductManully, setIsProductManully] = useState(true)
    const [ProductEntry, setProductEntry] = useState([])
    const [productItems, setProductItems] = useState([])
    const { userData } = CheckUserProvider();

    useEffect(async () => {
        if (userData) {
          try {
              const getProducts = await getProductDocumentWithUserId(userData.uid);
              setProductItems(getProducts);
            console.log('getProducts', getProducts)
          } catch (error) {
            console.log('Error Occur in Get Products And Sales', error)
          }
        }
    }, [userData])

    useEffect(async () => {
        try {
            const getProductAndSales = await getProductAndSalesDocumentWithUniqueId(productAndSalesId);
            setTimeout(() => {
                mapValues(getProductAndSales[0], (value, key) => setValue(key, value));
            });
            setExpiryDate(getProductAndSales[0]?.ExpiryDate);
            setIsEnabledProductSize(getProductAndSales[0]?.ProductSize == "Others" ? true : false)
        } catch(error) {
            console.log("Error Occur in Update Product", error)
        }
    }, []);


    const onSubmit = async (data) => {
        setIsLoading(true);
        var newProductAndSales = {};
        newProductAndSales._id = _id;
        newProductAndSales.uniqueId = productAndSalesId;
        newProductAndSales.userId = userData.uid;
        newProductAndSales.ProductName = data.ProductName;
        newProductAndSales.ProductType = data.ProductType;
        newProductAndSales.ProductSize = data.ProductSize
        newProductAndSales.OthersProductSize = isEnabledProductSize ? data.OthersProductSize : '';
        newProductAndSales.HSNCode = data.HSNCode;
        newProductAndSales.GSTClass = data.GSTClass;
        newProductAndSales.PrimaryPack = data.PrimaryPack;
        newProductAndSales.SecondaryPack = data.SecondaryPack;
        newProductAndSales.PackConversion = data.PackConversion;
        newProductAndSales.StockAsPerPrimaryPack = data.StockAsPerPrimaryPack;
        newProductAndSales.MRPAsPerPrimaryPack = data.MRPAsPerPrimaryPack;
        newProductAndSales.SellingPriceAsPerPrimaryPack = data.SellingPriceAsPerPrimaryPack;
        newProductAndSales.Discount = data.Discount;
        newProductAndSales.SchemeQuantity = data.SchemeQuantity;
        newProductAndSales.PackAsPerSchemeQuantity = data.PackAsPerSchemeQuantity;
        newProductAndSales.SchemeReward = data.SchemeReward;
        newProductAndSales.PackAsPerSchemeReward = data.PackAsPerSchemeReward;
        newProductAndSales.ProductEntry = ProductEntry
        if(isExpiryDateModified) {
            newProductAndSales.ExpiryDate = ExpiryDate;
        }
        try {
            var productAndSales = updateProductAndSalesDocument(newProductAndSales);
            if (productAndSales) {
                setOpenPopup(false);
                setNotificationMessage('Product And Sales Record Updated successfully.');
                setOpenNotify(true);
                setAlertType('success');
                setIsLoading(false);
                refreshData()
                // setTimeout(routeToPages, 2000);
            } else {
                setNotificationMessage('Something went wrong, Please try again later!!');
                setOpenNotify(true);
                setAlertType('error');
                setIsLoading(false);
                history.push('/retailer/create-product-and-sales');
            }
        }  catch (error) {
            console.error(error);
            setNotificationMessage('Something went wrong, Please try again later!!');
            setOpenNotify(true);
            setAlertType('error');
            setIsLoading(false);
            history.push('/retailer/create-product-and-sales');
        }
    };

    const routeToPages = () => {
        history.push('/retailer/all-product-and-sales');
    }

    const handleExpiryDateChange = (e) => {
        setExpiryDate(dateFormatter(e.target.value));
        setIsExpiryDateModified(true);
    }

    const handleOnSearch = (string, results) => {
      // onSearch will have as the first callback parameter
      // the string searched and for the second the results.
      console.log('handleOnSearch', string, results)
    }
  
    const handleOnHover = (result) => {
      // the item hovered
      console.log('handleOnHover', result)
    }

    const handleOnSelect = (item) => {
      // the item selected
      console.log('handleOnSelect', item)
      setProductEntry([...ProductEntry, item])
      setTimeout(() => {
        mapValues(item, (value, key) => setValue(key, value))
      })
    }

    const handleOnFocus = () => {
      console.log('Focused')
    }

    const formatResult = (item) => {
      return (
        <>
          <span style={{ display: 'block', textAlign: 'left' }}>
            {item.ProductName}
          </span>
        </>
      )
    }

    return (
        <>
            <div className={classes.root}>
                <Helmet>
                    <meta name="description" content="Use this page to update Product And Sales." />
                    <title>Update Product And Sales | Kaipsool Pharmatech</title>
                </Helmet>
                <div className="updateProduct">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            <h5 className="mt-3">Product Basic Details: &nbsp;
                            {IsProductManully ? (
                                <VisibilityOffIcon
                                    onClick={() => {
                                    setIsProductManully(false)
                                    setTimeout(() => {
                                        mapValues(ProductEntry, (value, key) =>
                                            setValue(key, value),
                                        )
                                    })
                                    }}
                                />
                                ) : (
                                <VisibilityIcon
                                    onClick={() => {
                                    setIsProductManully(true)
                                    setTimeout(() => {
                                        mapValues(ProductEntry, (value, key) =>
                                        setValue(key, value),
                                        )
                                    })
                                    }}
                                />
                            )} </h5>
                            <div className="row mb-3">
                              <div className="col-md-6 mb-2">
                                <ReactSearchAutocomplete
                                  items={productItems}
                                  placeholder="Search Product..."
                                  fuseOptions={{ keys: ['ProductName'] }}
                                  // necessary, otherwise the results will be blank
                                  resultStringKeyName="ProductName"
                                  onSearch={handleOnSearch}
                                  onHover={handleOnHover}
                                  onSelect={handleOnSelect}
                                  onFocus={handleOnFocus}
                                  autoFocus
                                  formatResult={formatResult}
                                  styling={{
                                    borderRadius: '8px',
                                  }}
                                />
                              </div>
                            </div>
                            <div className={IsProductManully ? "row PartyManully" : "row InactivePartyManully"}>
                                <div className="col-md-6 mb-2">
                                    Product Name <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                    <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.ProductName })}
                                        name="ProductName" autoComplete="none"
                                        ref={register({ required: 'Please enter Product Name!' })} />
                                    <small className="form-text text-danger">{errors.ProductName && errors.ProductName.message}</small>
                                </div>
                                <div className="col-md-6 mb-2">
                                    Product Type <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                    {/* <input type="text" 
                                        className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.ProductType })}
                                        name="ProductType" 
                                        autoComplete="none"
                                        ref={register({ required: 'Please enter Product Type!' })} /> */}
                                    <select 
                                        className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.ProductType })} 
                                        aria-label="Default select example"
                                        name="ProductType" ref={register({
                                            required: 'Please select Product Type!',
                                            validate: {
                                                defaultValue: value => value !== "Select Option" || 'Please select Product Type!'
                                            }
                                        })} defaultValue="Select Product Type" >
                                        <option value="Select Option">Select Option</option>
                                        <option value={'Tablet'}>{'Tablet'}</option>
                                        <option value={'Capsule'}>{'Capsule'}</option>
                                        <option value={'Injection'}>{'Injection'}</option>
                                        <option value={'Ampoule'}>{'Ampoule'}</option>
                                        <option value={'Condom'}>{'Condom'}</option>
                                        <option value={'Powder'}>{'Powder'}</option>
                                        <option value={'Oil'}>{'Oil'}</option>
                                        <option value={'Gel'}>{'Gel'}</option>
                                        <option value={'Ointment'}>{'Ointment'}</option>
                                        <option value={'Syrup'}>{'Syrup'}</option>
                                        <option value={'Cream'}>{'Cream'}</option>
                                        <option value={'Saline'}>{'Saline'}</option>
                                        <option value={'Spray'}>{'Spray'}</option>
                                        <option value={'Gloves'}>{'Gloves'}</option>
                                        <option value={'Gelatin'}>{'Gelatin'}</option>
                                        <option value={'Other'}>{'Other'}</option>
                                    </select>
                                    <small className="form-text text-danger">{errors.ProductType && errors.ProductType.message}</small>
                                </div>
                                <div className="col-md-4 mb-2">
                                    Product Size
                                    {/* <input type="text" 
                                        className={classNames("form-control registerEmp__textbox")}
                                        name="ProductSize" 
                                        autoComplete="none"
                                        ref={register()} /> */}
                                    <select 
                                        className={classNames("form-select registerEmp__textbox")} 
                                        aria-label="Default select example"
                                        name="ProductSize" ref={register()} 
                                        onChange={(event)=> {
                                            setIsEnabledProductSize(event.target.value == "Others" ? true : false)
                                        }}
                                        defaultValue="Select Product Size" >
                                        <option value="Select Option">Select Option</option>
                                        <option value={'5ml'}>{'5ml'}</option>
                                        <option value={'10ml'}>{'10ml'}</option>
                                        <option value={'40mg'}>{'40mg'}</option>
                                        <option value={'200gm'}>{'200gm'}</option>
                                        <option value={'Others'}>{'Others'}</option>
                                    </select>
                                    {isEnabledProductSize && <>
                                        Product Size <small>(if not in list)</small> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                        <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.OthersProductSize })}
                                            name="OthersProductSize" autoComplete="none"
                                            placeholder="Enter Product Size if not in list"
                                            ref={register({ required: 'Please enter Product Size!' })} />
                                        <small className="form-text text-danger">{errors.OthersProductSize && errors.OthersProductSize.message}</small>
                                    </>}
                                </div>
                                <div className="col-md-4 mb-2">
                                    HSN Code
                                    <input type="text" 
                                        className={classNames("form-control registerEmp__textbox")}
                                        name="HSNCode" 
                                        autoComplete="none"
                                        ref={register()} />
                                </div>
                                <div className="col-md-4 mb-2">
                                    GST Class <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                    {/* <input type="text" 
                                        className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.GSTClass })}
                                        name="GSTClass" 
                                        autoComplete="none"
                                        ref={register({ required: 'Please enter GST Class!' })} /> */}
                                    <select 
                                        className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.GSTClass })} 
                                        aria-label="Default select example"
                                        name="GSTClass" ref={register({
                                            required: 'Please select GST Class!',
                                            validate: {
                                                defaultValue: value => value !== "Select Option" || 'Please select GST Class!'
                                            }
                                        })} defaultValue="Select GST Class" >
                                        <option value="Select Option">Select Option</option>
                                        <option value={'Nil'}>{'Nil'}</option>
                                        <option value={'5'}>{'5%'}</option>
                                        <option value={'12'}>{'12%'}</option>
                                        <option value={'18'}>{'18%'}</option>
                                        <option value={'28'}>{'28%'}</option>
                                    </select>
                                    <small className="form-text text-danger">{errors.GSTClass && errors.GSTClass.message}</small>
                                </div>
                            </div>
                            <h5 className="mt-3">Sales Details:</h5>
                            <div className="col-md-4 mb-2">
                                Primary Pack <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.PrimaryPack })}
                                    name="PrimaryPack" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter Primary Pack!' })} />
                                    <small className="form-text text-danger">{errors.PrimaryPack && errors.PrimaryPack.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Secondary Pack <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.SecondaryPack })}
                                    name="SecondaryPack" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter Secondary Pack!' })} />
                                    <small className="form-text text-danger">{errors.SecondaryPack && errors.SecondaryPack.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Pack Conversion <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.PackConversion })}
                                    name="PackConversion" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter Pack Conversion!' })} />
                                    <small className="form-text text-danger">{errors.PackConversion && errors.PackConversion.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Stock (As per Primary Pack) <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.StockAsPerPrimaryPack })}
                                    name="StockAsPerPrimaryPack" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter Stock (As per Primary Pack)!' })} />
                                    <small className="form-text text-danger">{errors.StockAsPerPrimaryPack && errors.StockAsPerPrimaryPack.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                MRP (as per Primary Pack) <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.MRPAsPerPrimaryPack })}
                                    name="MRPAsPerPrimaryPack" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter MRP (as per Primary Pack)!' })} />
                                    <small className="form-text text-danger">{errors.MRPAsPerPrimaryPack && errors.MRPAsPerPrimaryPack.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Selling Price (as per primary pack) <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.SellingPriceAsPerPrimaryPack })}
                                    name="SellingPriceAsPerPrimaryPack" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter Selling Price (as per primary pack)!' })} />
                                    <small className="form-text text-danger">{errors.SellingPriceAsPerPrimaryPack && errors.SellingPriceAsPerPrimaryPack.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Discount
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox")}
                                    name="Discount" 
                                    autoComplete="none"
                                    ref={register()} />
                            </div>
                            <div className="col-md-6 mb-2">
                                Expiry Date
                                <DatePickerComponent
                                    id="ExpiryDate"
                                    name="ExpiryDate"
                                    value={ExpiryDate}
                                    cssclassName="e-outline"
                                    onChange={(e) => handleExpiryDateChange(e)}
                                    ref={register()}
                                />
                            </div>
                            <h5 className="mt-3">Scheme Details:</h5>
                            <div className="col-md-3 mb-2">
                                Scheme Quantity
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox")}
                                    name="SchemeQuantity" 
                                    autoComplete="none"
                                    ref={register()} />
                            </div>
                            <div className="col-md-3 mb-2">
                                Pack (as per Scheme Quantity)
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox")}
                                    name="PackAsPerSchemeQuantity" 
                                    autoComplete="none"
                                    ref={register()} />
                            </div>
                            <div className="col-md-3 mb-2">
                                Scheme Reward
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox")}
                                    name="SchemeReward" 
                                    autoComplete="none"
                                    ref={register()} />
                            </div>
                            <div className="col-md-3 mb-2">
                                Pack (as per Scheme Reward)
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox")}
                                    name="PackAsPerSchemeReward" 
                                    autoComplete="none"
                                    ref={register()} />
                            </div>
                            <div className="col-sm-12 text-right mt-2">
                                <div className="d-flex justify-content-center">
                                    <div className="p-2">
                                        <Button type="submit" variant="contained" className="registerEmp__btnLogin">
                                            {isLoading ? <CircularProgress size={18} /> : 'Update Product And Sales'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default UpdateProductAndSales
